import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const CONSENT_KEY = "atelier-cookie-consent-v1";
const OPEN_SETTINGS_EVENT = "atelier:open-cookie-settings";

function readConsent() {
  try {
    const saved = localStorage.getItem(CONSENT_KEY);
    const parsed = saved ? JSON.parse(saved) : null;
    if (!parsed || parsed.necessary !== true || typeof parsed.savedAt !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function openCookieSettings() {
  window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT));
}

export function CookieConsent() {
  const [consent, setConsent] = useState(readConsent);
  const [showSettings, setShowSettings] = useState(false);
  useEffect(() => {
    const openSettings = () => {
      setShowSettings(true);
    };
    window.addEventListener(OPEN_SETTINGS_EVENT, openSettings);
    return () => window.removeEventListener(OPEN_SETTINGS_EVENT, openSettings);
  }, []);

  const saveConsent = () => {
    const choice = {
      necessary: true,
      savedAt: new Date().toISOString(),
    };
    try {
      localStorage.setItem(CONSENT_KEY, JSON.stringify(choice));
    } catch {
      // Keep the choice for this page view if browser storage is unavailable.
    }
    setConsent(choice);
    setShowSettings(false);
  };

  if (consent && !showSettings) return null;

  return (
    <section
      className="fixed inset-x-0 bottom-0 z-[60] border-t bg-background shadow-2xl"
      aria-label="Preferencias de cookies"
      aria-live="polite"
      data-testid="cookie-consent"
    >
      <div className="container mx-auto flex max-w-6xl flex-col gap-5 px-4 py-5 md:flex-row md:items-center md:justify-between md:px-8">
        <div className="max-w-2xl">
          <h2 className="font-serif text-xl">Tu privacidad importa</h2>
          <p className="mt-1 text-sm leading-6 text-muted-foreground">
            Usamos el almacenamiento del navegador para recordar tu carrito y tus preferencias. Los datos de una compra se usan para gestionar el pedido y entregar el producto; no para publicidad. Consulta la{" "}
            <Link to="/legal/cookies" className="underline underline-offset-4">política de cookies</Link>{" "}
            y la{" "}
            <Link to="/legal/privacy" className="underline underline-offset-4">información sobre datos personales</Link>.
          </p>
          {showSettings && (
            <p className="mt-3 text-sm leading-6 text-muted-foreground">
              Actualmente solo usamos almacenamiento necesario para el carrito, el idioma, la moneda y esta elección. No hay cookies opcionales de analítica o publicidad activadas.
            </p>
          )}
        </div>
        <div className="flex flex-wrap gap-2">
          {showSettings ? (
            <>
              <button type="button" onClick={() => setShowSettings(false)} className="min-h-10 border px-4 text-sm hover:bg-muted">
                Volver
              </button>
              <button type="button" onClick={() => saveConsent()} className="min-h-10 bg-foreground px-4 text-sm text-background hover:opacity-90">
                Guardar elección
              </button>
            </>
          ) : (
            <>
              <button type="button" onClick={() => saveConsent(false)} className="min-h-10 border px-4 text-sm hover:bg-muted">
                Solo necesarias
              </button>
              <button type="button" onClick={() => setShowSettings(true)} className="min-h-10 border px-4 text-sm hover:bg-muted">
                Configurar
              </button>
              <button type="button" onClick={() => saveConsent()} className="min-h-10 bg-foreground px-4 text-sm text-background hover:opacity-90">
                Aceptar
              </button>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
